"use strict";

document.addEventListener("DOMContentLoaded", function (event) {
    if(jQuery(".announcement-slider").hasClass('slick-initialized')) return;
  jQuery(".announcement-slider").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 15000,
    arrows: false,
    swipe: false,
    slidesToShow: 1,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
});



// if (window.matchMedia("(min-width: 992px)").matches) {
//     document.querySelectorAll('.collection-tabs .collection-tab').forEach(button => {
//       button.addEventListener('click', function () {
//         document.querySelectorAll('.collection-tabs .collection-tab').forEach(insidebtn => {
//           insidebtn.classList.remove('filter_active');
//         });
//         let filterValue = this.getAttribute('data-filter');
//         console.log(filterValue, "filterValue");
//         document.querySelectorAll('.filter_sidebar_general .list_categories .cat-item a').forEach(item => {

//           if(item.getAttribute('data-attr') === filterValue){
//             button.classList.add('filter_active');
//             item.click();
//           }
//         });
//       });
//     });
//     }
//     if (window.matchMedia("(max-width: 991px)").matches) {
//     document.querySelectorAll('.collection-tabs .collection-tab').forEach(button => {
//       button.addEventListener('click', function () {
//         document.querySelectorAll('.collection-tabs .collection-tab').forEach(insidebtn => {
//           insidebtn.classList.remove('filter_active');
//         });
//         let filterValue = this.getAttribute('data-filter');
//         console.log(filterValue, "filterValue");
//         document.querySelectorAll('.filter_sidebar .list_categories .cat-item a').forEach(item => {
//           if(item.getAttribute('data-attr') === filterValue){
//             button.classList.add('filter_active');
//             item.click();
//           }
//         });
//       });
//     });
//     }



// Set correct active tab based on URL constraint
document.addEventListener("DOMContentLoaded", function() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentConstraint = urlParams.get('constraint');
  
  // Also check URL path for categories_wall-lights, categories_table-lamps, etc.
  const currentPath = window.location.pathname;
  let activeConstraint = currentConstraint;
  
  // Check if URL path contains category info (for pagination)
  if (!activeConstraint && currentPath.includes('/categories_')) {
    const pathMatch = currentPath.match(/\/categories_([^\/\?]+)/);
    if (pathMatch) {
      activeConstraint = 'categories_' + pathMatch[1];
    }
  }
  
  if (activeConstraint) {
    const tabs = document.querySelectorAll('.collection-tabs .collection-tab');
    if (tabs.length > 0) {
      // Remove active class from all tabs
      tabs.forEach(tab => {
        if (tab && tab.classList) {
          tab.classList.remove('filter_active');
        }
      });
      
      // Add active class to matching tab
      tabs.forEach(tab => {
        if (tab && tab.classList && tab.getAttribute('data-filter') === activeConstraint) {
          tab.classList.add('filter_active');
        }
      });
    }
  }
});

if (window.matchMedia("(min-width: 992px)").matches) {
    const tabs = document.querySelectorAll('.collection-tabs .collection-tab');
    if (tabs.length > 0) {
      tabs.forEach(button => {
        if (button) {
          button.addEventListener('click', function () {
            const allTabs = document.querySelectorAll('.collection-tabs .collection-tab');
            allTabs.forEach(insidebtn => {
              if (insidebtn && insidebtn.classList) {
                insidebtn.classList.remove('filter_active');
              }
            });
            
            let filterValue = this.getAttribute('data-filter');
            const filterItems = document.querySelectorAll('.filter_sidebar_general .list_categories .cat-item a');
            
            filterItems.forEach(item => {
              if (item && item.getAttribute('data-attr') === filterValue) {
                if (button && button.classList) {
                  button.classList.add('filter_active');
                }
                window.location.href = item.href;
              }
            });
          });
        }
      });
    }
}
if (window.matchMedia("(max-width: 991px)").matches) {
    const mobileTabs = document.querySelectorAll('.collection-tabs .collection-tab');
    if (mobileTabs.length > 0) {
      mobileTabs.forEach(button => {
        if (button) {
          button.addEventListener('click', function () {
            const allTabs = document.querySelectorAll('.collection-tabs .collection-tab');
            allTabs.forEach(insidebtn => {
              if (insidebtn && insidebtn.classList) {
                insidebtn.classList.remove('filter_active');
              }
            });
            
            let filterValue = this.getAttribute('data-filter');
            const filterItems = document.querySelectorAll('.filter_sidebar .list_categories .cat-item a');
            
            filterItems.forEach(item => {
              if (item && item.getAttribute('data-attr') === filterValue) {
                if (button && button.classList) {
                  button.classList.add('filter_active');
                }
                window.location.href = item.href;
              }
            });
          });
        }
      });
    }
}
    
    